var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgValueForMoney = function SvgValueForMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2L14.85 8.4L22 9.25L16.5 13.97L18.18 21L12 17.27L5.82 21L7.5 13.97L2 9.25L9.15 8.4L12 2Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.5C14 7.5 12.5 7 11.5 7C10 7 8.5 8.5 8.5 11C8.5 13.5 10 15 11.5 15C12.5 15 14 14.5 14.5 13.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10H12",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12H12",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))));
};
export default SvgValueForMoney;